import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { apiHost } from '@/config'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title:"Kontur.IT - Produkty software'owe",
    }
  },
  {
    path: '/kim-jestesmy',
    name: 'kim-jestesmy',
    meta: {
      title:'Kim jesteśmy? - Kontur.IT',
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/co-mozemy-dla-ciebie-zrobic',
    name: 'co-mozemy-dla-ciebie-zrobic',
    meta: {
      title:'Co możemy dla Ciebie zrobić? - Kontur.IT',
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Offer.vue')
  },
  {
    path: '/skontaktuj-sie-z-nami',
    name: 'skontaktuj-sie-z-nami',
    meta: {
      title:'Skontaktuj się z nami! - Kontur.IT',
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
  },
  {
    path: '/czy-wiecie-ze',
    name: 'czy-wiecie-ze',
    meta: {
      title:'Czy wiecie że... - Kontur.IT',
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/DoYouKnow.vue')
  },
  {
    path: '/polityka-prywatnosci',
    name: 'polityka-prywatnosci',
    meta: {
      title:'Polityka prywatności - Kontur.IT',
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPolicy.vue')
  },
  {
    path: '/czy-wiecie-ze/gliwicka-radiostacja',
    name: 'gliwicka-radiostacja',
    meta: {
      title:'Gliwicka Radiostacja - Kontur.IT',
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Gliwicka.vue')
  },
  {
    path: '/mapa-strony',
    name: 'mapa-strony',
    meta: {
      title:'Mapa Strony - Kontur.IT',
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/SiteMap.vue')
  }
]

const router = new VueRouter({
  base: '/',
  mode: 'history',
  routes
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));
  next();
});

export default router